import './OCRUpload.scss'

import React, { ChangeEvent, MouseEvent, useEffect, useRef, useState } from "react";
import { AddOutline } from "antd-mobile-icons";
import { Modal } from 'antd-mobile';

import { PhotoProvider, PhotoSlider } from 'react-photo-view';
import 'react-photo-view/dist/index.css';

export interface UploadFile extends File {
  name: string;
  url: string;
  uid: string;
  thumbUrl: string;
}

type OCRUploadProps = {
  fileList: UploadFile[];
  preview?: boolean;
  onUpload?: (file: File)=> void | Promise<void>;
  onRemove?: (file: UploadFile)=> void;
  onPreview?: (file: UploadFile)=> void;
}

const OCRUpload = (props: OCRUploadProps)=> {

  const wrapperRef = useRef<HTMLDivElement>(null)

  const [visible, setVisible] = useState(false)
  const [previewIndex, setPreivewIndex] = useState(0)

  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const [styl, setStyl] = useState({
    width: -1,
    height: -1,
  });

  useEffect(()=> {
    setFileList(props.fileList ?? [])
  }, [props.fileList])

  useEffect(() => {
    if (wrapperRef.current && styl.width === -1) {
      const length = 4;
      const { clientWidth } = wrapperRef.current;
      const gap = (length - 1) * 8;
      const width = (clientWidth - gap - 8 - 8) / length;
      setStyl({
        width,
        height: width,
      });
    }
  }, [wrapperRef.current]);

  const onChange = async (event: ChangeEvent<HTMLInputElement>)=> {

    const files = event.target.files;

    if (null === files || !files[0]) {
      return;
    }

    const file = files[0]

    const [_, ext] = file.type.split('/')
    if(!['.png', '.jpg', '.jpeg'].includes(`.${ext}`)) {
      Modal.alert('提示', '上传格式不允许')
      event.target.value = ''
      return false
    }

    if(props.onUpload) {
      await props.onUpload(file)
    }

    event.target.value = ''
  }

  const showPreviewer = (index: number)=> {
    setPreivewIndex(index)
    setVisible(true)
  }

  const removeIt = (file: UploadFile, event: MouseEvent)=> {
    event.stopPropagation()
    props.onRemove && props.onRemove(file)
  }

  return (
    <>
      <div ref={wrapperRef} className="upload-wrapper">
        <ul>
          {fileList.map((f, i) => (
            <li key={f.uid}>
              <div onClick={ ()=> showPreviewer(i) } className="inner" style={styl}>
                <img src={f.thumbUrl} alt="" />
                {!props.preview && (
                  <button
                    onClick={ (e)=> removeIt(f, e) }
                    className="remove"
                    type="button"
                  ></button>
                )}
              </div>
            </li>
          ))}
          {!props.preview && fileList.length < 21 && (
            <li>
              <div className="inner picker" style={styl}>
                <input
                  onChange={onChange}
                  accept="image/png, image/jpeg"
                  type="file"
                />
                <AddOutline />
              </div>
            </li>
          )}
        </ul>
      </div>
      <PhotoSlider
        photoClosable
        images={fileList.map(({ url }) => ({ src: url }))}
        visible={visible}
        onClose={() => setVisible(false)}
        index={previewIndex}
        introVisible={true}
        onIndexChange={ (i: number)=> setPreivewIndex(i)}
      />
    </>
  );
}

export default OCRUpload